import { render, staticRenderFns } from "./LawLedesDetailForm.vue?vue&type=template&id=47942240&"
import script from "./LawLedesDetailForm.vue?vue&type=script&lang=js&"
export * from "./LawLedesDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesDetailForm.vue?vue&type=style&index=0&id=47942240&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports